var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"GradesPage py-5"},[_c('h1',[_vm._v("Academic success")]),_c('v-data-table',{staticClass:"elevation-1 mt-6",attrs:{"item-key":"name","loading":"","loading-text":"Loading... Please wait"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }